import CheckoutPage from 'features/checkout/pages';

import { PendingSubmittedOrderRecovery } from 'components/pending-submitted-order-recovery';
import { routes } from 'utils/routing';

export default function Checkout() {
  return (
    <>
      <CheckoutPage />
      <PendingSubmittedOrderRecovery checkoutRoute={routes.cartCheckout} />
    </>
  );
}
